import { Box } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Input, Modal, Select } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import warning from "./../../assets/warningblack.svg";

//  This function(fetchv1DeviceDetailsEndPoint) is currently not in use, when using this in future read below comments
//  Kindly note "fetchv1DeviceDetailsEndPoint" end point has been switched from V2 to V1,
//  when using this function kindly take care of making payload related changes
import {
  fectchOrgLocEndPoint,
  setDeviceBulkEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

import ToastNotification from "../../global/components/ToastNotification";
import bulkupdatealerticon from "../../assets/bulkupdatealerticon.svg";
import { ArrowLeftOutlined } from "@ant-design/icons";
const { Option } = Select;

const BulkDeviceDetails = ({
  visible,
  onClose,
  deviceList,
  onBulkUpdated
}) => {
  const initialDeviceInfo = {
    assetType: "",
    deviceids: [],
    deviceType: "ts.device.tgAssetTracker",
    organization: "",
    deviceLocation: "",
    gatewayType: "Mobile",
    name: "",
  };

  const location = useLocation();
  const [hovered, setHovered] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [count, setCount] = useState(deviceList?.length || 0);
  const [deviceInfo, setDeviceInfo] = useState(initialDeviceInfo);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [isConfirmationView, setIsConfirmationView] = useState(false);
  const filters = useSelector((state) => state.devices.filters);
  const isFiltered = useSelector((state) => state.devices.deviceCounts);
  const deviceCounts = useSelector((state) => state.devices.deviceCounts);
  const organizations = useSelector(
    (state) => state.alert.bulkUpdate.organizations
  );
  const locations = useSelector((state) => state.alert.bulkUpdate.locations);

  const filtersFields = useSelector(
    (state) => state.alert.bulkUpdate.filters.fields
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchFilteredDevices = async () => {
    const body = {
      accountname: sessionStorage.getItem("accountId"),
      filter:{
        $sort: [
        {
          field: "createdon",
          order: "asc",
        },
      ],
      } 
    };
    let filterConditions = [];
    if (deviceInfo.deviceType) {
      if (deviceInfo.deviceType === "ts.device.tgAssetTracker") {
        filterConditions.push(`(kind eq '${deviceInfo.deviceType}') OR (kind eq 'ts.device.cHeAssetTracker')`);
      } else {
        filterConditions.push(`(kind eq '${deviceInfo.deviceType}')`);
      }
    }
    if (deviceInfo.deviceLocation) {
      filterConditions.push(
        `($/customdata/locationName eq '${deviceInfo.deviceLocation}')`
      );
    }
    if (deviceInfo.organization) {
      filterConditions.push(
        `($/customdata/organizationName eq '${deviceInfo.organization}')`
      );
    }
    if (deviceInfo.name) {
      filterConditions.push(`(name LIKE '${deviceInfo.name}')`);
    }
    if (filterConditions.length > 0) {
      body.filter["$selection"] = filterConditions.join(" AND ");
    }

    try {
      const response = await fetch(fectchOrgLocEndPoint(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify(body),
      });

      if (response.status === 200) {
        const data = await response.json();
        setCount(data.length);
        setDeviceInfo((prevState) => ({
          ...prevState,
          deviceids: data.map((item) => item.id),
        }));
        setIsConfirmationView(true);
      } else {
        console.error("Error fetching filtered devices");
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const handleApiCall = () => {
    fetchFilteredDevices();
  };

  const handleBackButton = () => {
    setIsConfirmationView(false);

  };

  const handleInputChange = (field, value) => {
    setDeviceInfo((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const onApply = async () => {
    const response = await fetch(setDeviceBulkEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        $filter: { deviceids: deviceInfo.deviceids },
        customdata: {
          gatewayType: deviceInfo.gatewayType,
        },
      }),
    });

    if (response.status === 200) {
      setNotificationProps({
        type: "success",
        message: "Devices - Bulk edit",
        description: `Devices - Bulk edit updated successfully.`,
        duration: 3,
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
        onBulkUpdated();
      }, 3000);
    } else {
      setNotificationProps({
        type: "error",
        message: "Failed to update device",
        description:
          response?.error_description ||
          "An error occurred while updating.",
        duration: 3,
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    }
  };

  return (
    <Modal
      open={visible}
      //onCancel={() => closePopup()}
      onCancel={onClose}
      width={600}
      footer={null}
      maskClosable={true}
    >
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}
      {isConfirmationView && (
        <button className="bulkupdate-modal-back" onClick={handleBackButton}>
          <ArrowLeftOutlined />
        </button>
      )}

      <Box className="bulkalert-modal-content">
        <Grid2 item xs={12} sm={6} md={6} lg={6}>
          <div style={{ marginBottom: "10px" }}>
            <h2 className={"font-face-vzb page-heading-user"}>
              Devices - Bulk edit
            </h2>
          </div>
        </Grid2>
        {deviceCounts.total && !isConfirmationView && (
          <>
            <p>
              Choose the devices to be updated by adding query parameters below.
              Then enter the new values for the attributes to update.
            </p>
            <h4 className={"font-face-vzb page-sub-heading-user"}>
              Device query
            </h4>
            <Grid2 container spacing={1}>
              <Grid2 item xs={12}>
                <label htmlFor="name" className="input-label-user">
                  Name
                </label>
                <div className="input-container">
                  <Input
                    className="alert-box-size"
                    //value={filtersFields?.subject}
                    onChange={(e) =>
                      handleInputChange("name", e.target.value)
                    }
                  />
                  <p
                    style={{
                      marginTop: "10px",
                      color: "#6F7171",
                      fontSize: "12px",
                      marginBottom: "8px",
                    }}
                  >
                    Type a name
                  </p>
                </div>
              </Grid2>
              <Grid2 item xs={12}>
                <label htmlFor="device" className="input-label-user">
                  Device Model
                </label>
                <div className="input-container">
                  <Select
                    placeholder=""
                    style={{ width: "100%" }}
                    allowClear
                    size="large"
                    defaultValue={deviceInfo.deviceType}
                    onChange={(value) => handleInputChange("deviceType", value)}
                  >
                    <Option value="ts.device.tgAssetTracker">Gateway</Option>
                    <Option value="ts.device.ble" disabled>BLE Tag</Option>
                  </Select>
                </div>
              </Grid2>

              {/* <Grid2 item xs={6}>
                <div className="mb-3">
                  <label htmlFor="organization" className="input-label-user">
                    Organization
                  </label>
                  <div className="input-container">
                    <Select
                      className="alert-box-size"
                      value={
                        deviceInfo.organization
                      }
                      onChange={(value) =>
                        handleInputChange("organization", value)
                      }
                      options={organizationList.map((organization, index) => ({
                        key: `org-${index}-${organization.value}`,
                        value: organization.value,
                        label: organization.label,
                      }))}
                    />
                  </div>
                </div>
              </Grid2> */}
              {/* <Grid2 item xs={6}>
                <div className="mb-3">
                  <label htmlFor="location" className="input-label-user">
                    Location
                  </label>
                  <div className="input-container">
                    <Select
                      className="alert-box-size"
                      value={
                        deviceInfo.deviceLocation

                      }
                      onChange={(value) =>
                        handleInputChange("deviceLocation", value)
                      }
                      options={locationList.map((location, index) => ({
                        key: `loc-${index}-${location.value}`,
                        value: location.value,
                        label: location.label,
                      }))}
                    />
                  </div>
                </div>
              </Grid2> */}
            </Grid2>
            <h4 className={"font-face-vzb page-sub-heading-user"}>
              New values
            </h4>
            <div style={{ marginTop: 20 }}>
              <Grid2 item xs={6}>
                <div className="mb-3">
                  <label
                    htmlFor="target-device-profile"
                    className="input-label-user"
                  >
                    Target device profile
                  </label>
                  <div className="input-container">
                    <Select
                      placeholder=""
                      style={{ width: "100%" }}
                      allowClear
                      size="large"
                      value={deviceInfo.gatewayType}
                      onChange={(value) =>
                        handleInputChange("gatewayType", value)
                      }
                    >
                      <Option value="Mobile">Mobile Gateway</Option>
                      <Option value="Fixed">Fixed Gateway</Option>
                    </Select>
                  </div>

                  <div className="input-container">
                    <p
                      style={{
                        marginTop: "10px",
                        color: "#6F7171",
                        fontSize: "12px",
                      }}
                    >
                      Applies to GATEWAY devices only. Queues the selected
                      profile to be pushed to the device.{" "}
                    </p>
                  </div>
                </div>
              </Grid2>
            </div>
            <Grid2
              container
              marginTop={2}
              marginBottom={0.5}
              spacing={1}
              columns={{ xs: 12 }}
            >
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-cancel"
                    type="default"
                    shape="round"
                    onClick={onClose}
                    //onClick={onClose}
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "bold",
                      border: "1px solid black",
                    }}
                    size={"large"}
                  >
                    {"Cancel"}
                  </Button>
                </div>
              </Grid2>
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-save"
                    type="primary"
                    shape="round"
                    onClick={() => handleApiCall()}
                    style={{
                      width: "100%",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    size={"large"}
                  >
                    {"Update"}
                  </Button>
                </div>
              </Grid2>
            </Grid2>
          </>
        )}
        {isConfirmationView && (
          <div>
            <div className="alert-bulkupdate-msgbox">
              <div className="alert-bulkupdate-msg-header">
                <img src={bulkupdatealerticon} alt="bulkupdatealerticon" />
                <span className="font-face-vzb">View alerts</span>
              </div>
              <div className="alert-bulkupdate-msg">
                {count} devices match the query and will be updated.
              </div>
            </div>
            <p style={{ marginTop: "12px" }}>
              Are you sure you would like to update {count} devices?
            </p>
            <Grid2
              container
              marginTop={2}
              marginBottom={0.5}
              spacing={1}
              columns={{ xs: 12 }}
            >
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-cancel"
                    type="default"
                    shape="round"
                    onClick={handleBackButton}
                    //onClick={onClose}
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "bold",
                      border: "1px solid black",
                    }}
                    size={"large"}
                  >
                    {"Go Back"}
                  </Button>
                </div>
              </Grid2>
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-save"
                    type="primary"
                    shape="round"
                    onClick={
                      onApply
                    }
                    style={{
                      width: "100%",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    size={"large"}
                  >
                    {`Update ${count} devices`}
                  </Button>
                </div>
              </Grid2>
            </Grid2>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default BulkDeviceDetails;
